import SheetSubjectListPage from "../components/pages/SheetSubjectListPage";
import { RootTabScreenProps } from "../types";

export default function SetsScreen({}: RootTabScreenProps<"sets">) {
  return <SheetSubjectListPage kind="set" />;
}
